export const LeftArrow = () => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.50962 7.78867L15 0.57735L27.4904 7.78867V22.2113L15 29.4227L2.50962 22.2113V7.78867Z"
      stroke="#9F6B08"
    />
    <path
      d="M9.64645 14.6464C9.45118 14.8417 9.45118 15.1583 9.64645 15.3536L12.8284 18.5355C13.0237 18.7308 13.3403 18.7308 13.5355 18.5355C13.7308 18.3403 13.7308 18.0237 13.5355 17.8284L10.7071 15L13.5355 12.1716C13.7308 11.9763 13.7308 11.6597 13.5355 11.4645C13.3403 11.2692 13.0237 11.2692 12.8284 11.4645L9.64645 14.6464ZM20 14.5L10 14.5V15.5L20 15.5V14.5Z"
      fill="#9F6B08"
    />
  </svg>
);
